import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { LoadingSpinner, getSize, getColor } from '@lib/common';
import { SectionEditComponent } from './section-edit.component';
import { SectionPreviewComponent } from './section-preview.component';
import styled from 'styled-components';
import { Divider, Form, Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var decoratorHeight = '40px';
export var StyledTag = styled.div.withConfig({
  displayName: "sectioncomponent__StyledTag",
  componentId: "sc-3f6hms-0"
})(["position:absolute;top:-", ";left:0;padding:", " ", ";width:auto;height:", ";font-size:", ";font-weight:400;color:", ";text-align:center;background:", ";border-radius:", " ", " ", " ", ";"], decoratorHeight, getSize('padding8'), getSize('padding16'), decoratorHeight, getSize('typo16'), getColor('textIntWhite'), getColor('fillIntActive'), getSize('radiusSm'), getSize('radiusSm'), getSize('radius0'), getSize('radius0'));
export var StyledSpaceContainer = styled(Space).withConfig({
  displayName: "sectioncomponent__StyledSpaceContainer",
  componentId: "sc-3f6hms-1"
})(["position:relative;display:flex;flex-direction:column;width:100%;height:100%;cursor:pointer;.sticky-element1{position:absolute;top:getSize('padding0');left:getSize('padding0');visibility:hidden;z-index:100;}"]);
export var StyledSectionWrapper = styled(Form).withConfig({
  displayName: "sectioncomponent__StyledSectionWrapper",
  componentId: "sc-3f6hms-2"
})(["position:relative;margin-top:", ";min-height:140px;box-shadow:0px 3px 6px rgba(0,0,0,0.12);background:", ";border-radius:", " ", " ", " ", ";"], getSize('padding40'), getColor('fillBgWhite'), getSize('radius0'), getSize('radiusSm'), getSize('radiusSm'), getSize('radiusSm'));
export var StyledLine = styled(Divider).withConfig({
  displayName: "sectioncomponent__StyledLine",
  componentId: "sc-3f6hms-3"
})(["margin:", ";"], getSize('padding0'));
export var StyledSection = styled.div.withConfig({
  displayName: "sectioncomponent__StyledSection",
  componentId: "sc-3f6hms-4"
})(["padding:", " ", ";border-top:", ";border-radius:", " ", " ", ";"], getSize('padding16'), getSize('padding24'), function (_ref) {
  var theme = _ref.theme,
      $focus = _ref.$focus;
  return $focus ? "6px solid ".concat(getColor('fillIntActive')({
    theme: theme
  })) : 'none';
}, getSize('radius0'), getSize('radiusSm'), getSize('radiusSm'));
export var SectionFactory = function SectionFactory(_ref2) {
  var section = _ref2.section,
      disabled = _ref2.disabled,
      sectionIndex = _ref2.sectionIndex,
      isOnlyRemainingSection = _ref2.isOnlyRemainingSection,
      onDeleteSection = _ref2.onDeleteSection,
      onUpdateSection = _ref2.onUpdateSection,
      onSaveSection = _ref2.onSaveSection,
      onCancel = _ref2.onCancel,
      onCreateSection = _ref2.onCreateSection,
      isFocusedSection = _ref2.isFocusedSection,
      onSelectedSection = _ref2.onSelectedSection,
      handleGetPositionElement = _ref2.handleGetPositionElement,
      onEditSection = _ref2.onEditSection,
      hasUnsavedQuestionOrSectionChanges = _ref2.hasUnsavedQuestionOrSectionChanges,
      addSectionFileStatus = _ref2.addSectionFileStatus,
      file = _ref2.file,
      onResetAddSectionFileUseCase = _ref2.onResetAddSectionFileUseCase,
      onShowingUploadSectionFileModal = _ref2.onShowingUploadSectionFileModal,
      sectionLabel = _ref2.sectionLabel,
      onShowingUploadSectionAudioFileModal = _ref2.onShowingUploadSectionAudioFileModal,
      onDeletingAudioFile = _ref2.onDeletingAudioFile,
      editingFormItemId = _ref2.editingFormItemId,
      saveSectionStatus = _ref2.saveSectionStatus,
      editorLabels = _ref2.editorLabels;
  var isEditingSection = editingFormItemId === section.id.toString();
  var sectionCommonProps = {
    section: section,
    onDeleteSection: onDeleteSection,
    isOnlyRemainingSection: isOnlyRemainingSection,
    sectionIndex: sectionIndex,
    sectionLabel: sectionLabel
  };
  if (!section) return /*#__PURE__*/_jsx(LoadingSpinner, {});
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isEditingSection ? /*#__PURE__*/_jsx(SectionEditComponent, _objectSpread(_objectSpread({}, sectionCommonProps), {}, {
      onUpdateSection: onUpdateSection,
      onSaveSection: onSaveSection,
      onCancel: onCancel,
      addSectionFileStatus: addSectionFileStatus,
      file: file,
      onResetAddSectionFileUseCase: onResetAddSectionFileUseCase,
      onShowingUploadSectionFileModal: onShowingUploadSectionFileModal,
      onShowingUploadSectionAudioFileModal: onShowingUploadSectionAudioFileModal,
      onDeletingAudioFile: onDeletingAudioFile,
      saveSectionStatus: saveSectionStatus,
      editorLabels: editorLabels
    })) : /*#__PURE__*/_jsx(SectionPreviewComponent, _objectSpread(_objectSpread({}, sectionCommonProps), {}, {
      disabled: disabled,
      handleGetPositionElement: handleGetPositionElement,
      isFocusedSection: isFocusedSection,
      onSelectedSection: onSelectedSection,
      hasUnsavedQuestionOrSectionChanges: hasUnsavedQuestionOrSectionChanges,
      onEditSection: onEditSection,
      onCreateSection: onCreateSection
    }))
  });
};